'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _ListItem = require('components/ListItem/ListItem');

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var RecipientsListItem = (_class = (_temp = _class2 = function (_PureComponent) {
  (0, _inherits3.default)(RecipientsListItem, _PureComponent);

  function RecipientsListItem() {
    (0, _classCallCheck3.default)(this, RecipientsListItem);
    return (0, _possibleConstructorReturn3.default)(this, (RecipientsListItem.__proto__ || (0, _getPrototypeOf2.default)(RecipientsListItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(RecipientsListItem, [{
    key: 'onClick',
    value: function onClick() {
      var _props = this.props,
          recipient = _props.recipient,
          onClick = _props.onClick;

      if (onClick) {
        return onClick(recipient);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          className = _props2.className,
          recipient = _props2.recipient;


      return _react2.default.createElement(
        _ListItem2.default,
        {
          fullWidth: true,
          className: (0, _bind2.default)('cursor-pointer', className),
          onClick: this.onClick
        },
        _react2.default.createElement(
          'div',
          null,
          recipient.id
        ),
        _react2.default.createElement(
          'div',
          null,
          recipient.fullName
        ),
        _react2.default.createElement(
          'div',
          null,
          recipient.email
        )
      );
    }
  }]);
  return RecipientsListItem;
}(_react.PureComponent), _class2.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  recipient: _propTypes2.default.object
}, _class2.contextTypes = {
  push: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  recipient: {}
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'onClick', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'onClick'), _class.prototype)), _class);
exports.default = RecipientsListItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Recipients/RecipientsListItem/RecipientsListItem.js
// module id = 2092
// module chunks = 1